// extracted by css-extract-rspack-plugin
export default {"Title":"TitleAndStory_Title__3PK7A","EventLocationDetails":"TitleAndStory_EventLocationDetails__O3omj"};